var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightUsersProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#3CB4E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7226 8.21644L10.7488 15.1888L8.27761 12.7181C7.98406 12.4283 7.51155 12.4298 7.21976 12.7215C6.92806 13.0131 6.92656 13.4856 7.21642 13.7791L10.2181 16.7802C10.3588 16.921 10.5497 17 10.7487 17C10.9477 17 11.1385 16.921 11.2792 16.7802L18.7836 9.27741C19.0734 8.98392 19.0719 8.51151 18.7802 8.21978C18.4886 7.92805 18.0161 7.92655 17.7226 8.21644Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightUsersProfile);
export default __webpack_public_path__ + "static/media/rightUsersProfile.d023fdb35237b4aee47a807c836adad5.svg";
export { ForwardRef as ReactComponent };